import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-error-facturacion',
  templateUrl: './error-facturacion.component.html',
  styleUrls: ['./error-facturacion.component.scss']
})
export class ErrorFacturacionComponent implements OnInit {
    visibleError:boolean = true;
    detalle: any = [];
    
    constructor(
        private dialogRef: MatDialogRef<ErrorFacturacionComponent>,
        private route: Router,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) { }

    ngOnInit(): void {
        console.log('ErrorFacturacionComponent', this.data.error.data.detalle);
        this.detalle = JSON.parse( this.data.error.data.detalle );
    }

    cerrar(): void {
        this.dialogRef.close();
    }

    accionar(){
        this.visibleError = !this.visibleError;   
    }

    formatoOracion( mensaje){
        let nuevoMensaje = mensaje.charAt(0).toUpperCase() + mensaje.slice(1).replace(/[A-Z]/g, ' $&').toLowerCase();
        return nuevoMensaje;
    }

    acentuarPalabras(cadena) {
        let mapaAcentos = {
            'á': 'a',
            'é': 'e',
            'í': 'i',
            'ó': 'o',
            'ú': 'u',
            'Á': 'A',
            'É': 'E',
            'Í': 'I',
            'Ó': 'O',
            'Ú': 'U'
        };
    
        let palabras = cadena.split(' ');
        for (let i = 0; i < palabras.length; i++) {
            let palabra = palabras[i];
            let nuevaPalabra = '';
            for (let j = 0; j < palabra.length; j++) {
                let letra = palabra.charAt(j);
                if (mapaAcentos[letra]) {
                    nuevaPalabra += mapaAcentos[letra];
                } else {
                    nuevaPalabra += letra;
                }
            }
            palabras[i] = nuevaPalabra;
        }
    
        return palabras.join(' ');
    }

    convertirBooleano(valor: boolean): string {
        return valor ? "Si" : "No";
      }

}
